var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPermitsTab(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2083",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-document",
    className: "st0",
    d: "M0.8,2.3v10.4H10V7.5H4.8V2.3H0.8z M6.1,2.3v3.9H10L6.1,2.3z M2.2,4.9h1.3v1.3H2.2 V4.9z M2.2,7.5h1.3v1.3H2.2V7.5z M2.2,10.1h5.2v1.3H2.2V10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    className: "st0",
    d: "M11.4,6.1l-1.3-1.3c-0.1-0.1-0.1-0.2,0-0.3c0,0,0,0,0,0l0.3-0.3 c0.1-0.1,0.2-0.1,0.3,0c0,0,0,0,0,0l0.9,0.9l1.9-1.9c0.1-0.1,0.2-0.1,0.3,0c0,0,0,0,0,0l0.3,0.3c0.1,0.1,0.1,0.2,0,0.3c0,0,0,0,0,0 l-2.4,2.4C11.6,6.2,11.5,6.2,11.4,6.1C11.4,6.1,11.4,6.1,11.4,6.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermitsTab);
export default __webpack_public_path__ + "static/media/permits-tab.d37cbd01f50d32132092ebb6985a0d5c.svg";
export { ForwardRef as ReactComponent };